import { FilterBuilder } from '@/shared/utils';

/** A manifest records the collection slug as written in the automation code
 *  (`invoice_items`), while the library stores a display name ("Invoice
 *  items"). Both sides are reduced to lowercase space-separated words so the
 *  two can be matched. */
export function normalizeCollectionSlug(value: string): string {
  return value
    .toLowerCase()
    .replace(/[\s_-]+/g, ' ')
    .trim();
}

/** Shared shell for a Library row so an asset button, a collection link and an
 *  unresolved collection all read as the same object. */
export const LIBRARY_ROW_CLASS =
  'h-auto w-full min-w-0 justify-start gap-2 rounded-lg bg-layout px-3 py-2';

/**
 * Build the workspace-connections filter for a set of connection ids.
 *
 * Each id has to be its own OR branch. Chaining `.equals` on a single builder
 * ANDs the conditions, which asks for one row whose `connection_id` equals
 * every id at once — that matches nothing, so with two or more integrations
 * every card loses its descriptor and misreports its connection state. The
 * integrations panel builds the equivalent filter the same way.
 *
 * @returns the filter string, or `undefined` when there is nothing to ask for.
 */
export function buildConnectionsFilter(
  connectionIds: (string | undefined)[],
): string | undefined {
  const ids = connectionIds.filter((id): id is string => Boolean(id));
  if (ids.length === 0) return undefined;
  return FilterBuilder.create()
    .or(...ids.map(id => FilterBuilder.create().equals('connection_id', id)))
    .build();
}
